import React, { useEffect, useState } from 'react';
import './ExpandableTextareaWidget.scss';

type ExpandableTextareaWidgetProps = {
  id: string;
  title?: string;
  description?: string;
  required?: boolean;
  value?: string;
  error?: string[] | string;
  disabled?: boolean;
  onChange: (id: string, value: string) => void;
};

const getPreviewText = (value?: string) => {
  if (!value?.trim()) {
    return 'No hierarchy JSON configured.';
  }

  const lineCount = value.split(/\r?\n/).length;
  const characterCount = value.length;

  return `${lineCount} line${lineCount === 1 ? '' : 's'}, ${characterCount} character${characterCount === 1 ? '' : 's'}`;
};

const ExpandableTextareaWidget: React.FC<ExpandableTextareaWidgetProps> = ({
  id,
  title,
  description,
  required,
  value,
  error,
  disabled,
  onChange,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    setIsExpanded(false);
  }, [id]);

  return (
    <div className={`field expandable-textarea-widget ${error ? 'error' : ''}`}>
      <div className="expandable-textarea-widget-header">
        <label htmlFor={`${id}-textarea`}>
          {title}
          {required ? ' *' : null}
        </label>
      </div>
      {description ? <p className="help">{description}</p> : null}
      <label
        className="expandable-textarea-widget-toggle"
        htmlFor={`${id}-toggle`}
      >
        <input
          id={`${id}-toggle`}
          type="checkbox"
          checked={isExpanded}
          disabled={disabled}
          onChange={(event) => setIsExpanded(event.target.checked)}
          aria-controls={`${id}-textarea`}
        />
        <span>
          {isExpanded
            ? 'Minimize facet category values'
            : 'Maximize facet category values'}
        </span>
      </label>
      {!isExpanded ? (
        <div className="expandable-textarea-widget-preview">
          {getPreviewText(value)}
        </div>
      ) : null}
      {isExpanded ? (
        <textarea
          id={`${id}-textarea`}
          value={value || ''}
          rows={14}
          disabled={disabled}
          onChange={(event) => onChange(id, event.target.value)}
        />
      ) : null}
      {error ? (
        <div className="ui pointing red basic label">
          {Array.isArray(error) ? error.join(', ') : error}
        </div>
      ) : null}
    </div>
  );
};

export default ExpandableTextareaWidget;
